var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnselectMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 20"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 13",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5",
    d: "M248.527 17.95h3.308a.993.993 0 0 0 0-1.985h-3.308a.993.993 0 0 0 0 1.985",
    transform: "translate(-242.39 -9.522)",
    style: {
      fill: "#00402e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 6",
    d: "M248.527 26.533a.993.993 0 0 0 0 1.985h5.293a.993.993 0 0 0 0-1.985z",
    transform: "translate(-242.383 -15.859)",
    style: {
      fill: "#00402e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7",
    d: "M248.356 21.548h-6.536a2.993 2.993 0 0 1-2.978-3V5.054h7.618a1 1 0 0 0 0-2h-8.611a1 1 0 0 0-.993 1v14.492a4.989 4.989 0 0 0 4.964 5h6.537a1 1 0 0 0 0-2",
    transform: "translate(-235.998 -1.788)",
    style: {
      fill: "#00402e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8",
    d: "M272.432.472a3.76 3.76 0 0 0-3.741 3.769v2.773a3.768 3.768 0 0 0 2.748 3.63v10.307a.993.993 0 1 0 1.985 0V10.645a3.769 3.769 0 0 0 2.749-3.631V4.241a3.76 3.76 0 0 0-3.741-3.769m1.756 6.542a1.756 1.756 0 1 1-3.511 0V4.241a1.756 1.756 0 1 1 3.511 0z",
    transform: "translate(-255.032 -.232)",
    style: {
      fill: "#00402e"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnselectMenu);
export default __webpack_public_path__ + "static/media/ic-unselect-menu.74abe68d498c67dae48bd175834f06ae.svg";
export { ForwardRef as ReactComponent };